module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Appointments":"Appointments","New Appointment":"Nueva cita"},"es":{"Appointments":"Equipo","New Appointment":"Equipo"},"sw":{"Appointments":"Appointments","New Appointment":"New Appointment"}}')
  delete Component.options._Ctor
}
